import coreDataForm from './coreDataForm';
import type { Form } from '../../../common/types/form';
import type { Transfer } from '../../../common/types/transfer';
import type { Setting } from '../../../common/types/settings';

const transferForms = (advisors: Setting[]): Form<Transfer>[] => {
  return [coreDataForm(advisors)];
};

export default transferForms;
